"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getChallengeProgression = void 0;

var _getActivityProgressionForObjective = _interopRequireDefault(require("./getActivityProgressionForObjective"));

var getChallengeProgression = function getChallengeProgression(challenge) {
  var _ref, _ref$calculationState, _ref$calculationState2, _objectivesProgressio, _objectivesProgressio2, _objectivesProgressio3, _objectivesProgressio4, _objectivesProgressio5, _objectivesProgressio6, _objectivesProgressio7, _objectivesProgressio8;

  var conditions = challenge.conditions,
      groupChallenge = challenge.groupChallenge,
      userChallenge = challenge.userChallenge;
  var repeat = conditions.repeat,
      frequency = conditions.frequency,
      frequencyRepeat = conditions.frequencyRepeat,
      _conditions$combinati = conditions.combinations,
      combinations = _conditions$combinati === void 0 ? [] : _conditions$combinati;
  var currentChallenge = groupChallenge || userChallenge;
  var objectivesProgression = ((_ref = currentChallenge) === null || _ref === void 0 ? void 0 : (_ref$calculationState = _ref.calculationState) === null || _ref$calculationState === void 0 ? void 0 : (_ref$calculationState2 = _ref$calculationState.progression) === null || _ref$calculationState2 === void 0 ? void 0 : _ref$calculationState2.objectives) || [];

  if (combinations.length && userChallenge) {
    var _completedObjectives = objectivesProgression.filter(function (objective) {
      return objective.isFinished;
    }).length;
    var _goal = combinations.length;

    var _progressionPercentage = Math.floor(_completedObjectives / _goal * 100);

    return {
      progressionPercentage: _progressionPercentage,
      progressionValue: _completedObjectives,
      combinationsNumber: combinations.length,
      progressionDisplay: "".concat(_completedObjectives, "/").concat(_goal),
      isCompleted: _completedObjectives === _goal
    };
  }

  var frequenciesOrRepetitions = frequency ? (_objectivesProgressio = objectivesProgression[0]) === null || _objectivesProgressio === void 0 ? void 0 : _objectivesProgressio.frequencies : (_objectivesProgressio2 = objectivesProgression[0]) === null || _objectivesProgressio2 === void 0 ? void 0 : (_objectivesProgressio3 = _objectivesProgressio2.frequencies) === null || _objectivesProgressio3 === void 0 ? void 0 : (_objectivesProgressio4 = _objectivesProgressio3[0]) === null || _objectivesProgressio4 === void 0 ? void 0 : _objectivesProgressio4.repetitions;
  var completedObjectives = (frequenciesOrRepetitions === null || frequenciesOrRepetitions === void 0 ? void 0 : frequenciesOrRepetitions.filter(function (item) {
    return item === null || item === void 0 ? void 0 : item.isFinished;
  }).length) || 0;

  var _getActivityProgressi = (0, _getActivityProgressionForObjective["default"])({
    objective: conditions,
    activity: objectivesProgression === null || objectivesProgression === void 0 ? void 0 : (_objectivesProgressio5 = objectivesProgression[0]) === null || _objectivesProgressio5 === void 0 ? void 0 : (_objectivesProgressio6 = _objectivesProgressio5.frequencies) === null || _objectivesProgressio6 === void 0 ? void 0 : (_objectivesProgressio7 = _objectivesProgressio6[0]) === null || _objectivesProgressio7 === void 0 ? void 0 : (_objectivesProgressio8 = _objectivesProgressio7.repetitions) === null || _objectivesProgressio8 === void 0 ? void 0 : _objectivesProgressio8[0]
  }),
      percentageCompleted = _getActivityProgressi.percentageCompleted,
      challengeValue = _getActivityProgressi.value;

  var goal = frequencyRepeat && frequency ? frequencyRepeat : repeat;
  var progressionPercentage = goal ? Math.floor(completedObjectives / goal * 100) : (currentChallenge === null || currentChallenge === void 0 ? void 0 : currentChallenge.status) === 'SUCCESS' ? 100 : Math.floor(percentageCompleted || 0);
  var progressionValue = frequencyRepeat && frequency || repeat ? completedObjectives : challengeValue;
  return {
    progressionPercentage: progressionPercentage,
    progressionValue: progressionValue,
    progressionDisplay: goal ? "".concat(progressionValue, "/").concat(goal) : "".concat(progressionPercentage.toFixed(), "%"),
    isCompleted: progressionPercentage === 100
  };
};

exports.getChallengeProgression = getChallengeProgression;
var _default = getChallengeProgression;
exports["default"] = _default;
//# sourceMappingURL=getChallengeProgression.js.map